<template>
	<div class="betRoom">
		<header>
			<div class="g-header">
				<div class="left" @click="changego">
					<van-icon name="arrow-left" size="17px" />
				</div>
				<div class="middle fs-18">{{ $t('jiaoyidating') }}</div>
			</div>
			<div class="blockHeight"></div>
		</header>
		<div class="g-content">
			<div class="bet-head">
				<div class="bet-charge" @click="changewa">
					<div>{{ $t("ljcj") }}</div>
				</div>
				<view class="text-gold padding bet-property" style="margin-left: 20px;">
					<view>{{ $t("zongzichan") }}</view>
					<view class="text-bold" style="margin-top: 10px;">{{ user_quantity.money }}</view>
				</view>
				<view class="grid text-gold col-3 text-center">
					<view>
						<view style="font-size: 12px; line-height: 25px;">{{ $t("tzze") }}</view>
						<view style="font-size: 12px; line-height: 20px;">{{ amount0.toLocaleString() }}</view>
					</view>
					<view>
						<view style="font-size: 12px; line-height: 25px;">{{ $t("yffje") }}</view>
						<view style="font-size: 12px; line-height: 20px;">{{ amount1.toLocaleString() }}</view>
					</view>
					<view>
						<view style="font-size: 12px; line-height: 25px;">{{ $t("zxrs") }}</view>
						<view style="font-size: 12px; line-height: 20px;">{{ onlineNum }}</view>
					</view>
				</view>
			</div>
			<view class="bg-black padding" style="margin-top: -25px;">
				<view class="charts-box bg-black shadow"
					style="padding-right: 15px; padding-left: 15px; height: 130px; border: 1px solid rgb(184, 167, 138); border-radius: 5px;">
					<div ref="chartContainer" class="kline-chart"></div>
				</view>
			</view>
			<view class="bg-black padding" style="margin-top: -15px;">
				<view class="text-center bg-black shadow padding"
					style="border: 1px solid rgb(184, 167, 138); border-radius: 5px;">
					<view class="bg-black">
						<view class="text-gold" style="line-height: 30px;">
							<text class="text-xs">
								<span>{{ $t("lun") }}:<text style="font-size: 16px;">{{ issue.issue }}</text></span>
							</text>
							<text class="text-xl" style="padding-left: 7px;">
								<span v-if="gamePhase == 'betting'">{{ numbers.join('+ ') }} = ？</span>
								<span v-else-if="gamePhase == 'settlement'">结算中... = ？</span>
							</text>
							<text class="text-xs" style="padding-left: 5px;">
								<span>{{ $t("sycj") }}:
									<!-- <template v-if="game_status == 1 && !whether_close">
										<van-count-down :time="time">
											<template #default="timeData">
												<text>{{ timeData.minutes }}</text>:
												<text>{{ timeData.seconds }}</text>
											</template>
										</van-count-down>
									</template> -->
									<div class="custom-countdown">
										<span v-if="gamePhase == 'betting'">{{ remainingSeconds }}s</span>
										<span v-else-if="gamePhase == 'settlement'">0s</span>
									</div>
								</span>
							</text>
						</view>
						<view class="text-xl text-yellow" style="line-height: 20px;">{{ $t("jxz") }}</view>
					</view>
				</view>
			</view>
			<view class="bg-black padding" style="margin-top: -15px;">
				<view class="text-center bg-black shadow padding"
					style="border: 1px solid rgb(184, 167, 138); border-radius: 5px;">
					<view class="bg-black">
						<view class="text-gold" style="line-height: 30px;">
							<view v-if="last_issue" class="text-gold" style="line-height: 30px;">
								<text>
									<span style="font-size: 14px;">{{ last_issue.issue }} {{ $t("lunjieguo") }}</span>
								</text>
								<view></view>
								<text style="padding-left: 7px; padding-right: 8px;">
									<span style="font-size: 14px;">
										{{ last_issue.site_1 }}+
										{{ last_issue.site_2 }}+
										{{ last_issue.site_3 }}=
										{{ last_issue.code }}
									</span>
								</text>
								<template v-if="last_issue && last_issue.base">
									<text class="cu-tag radius"
										:class="last_issue.base[1] === '涨' ? 'bg-red' : 'bg-green' ">
										<span>{{ $t(last_issue.base[0]) }}</span>
									</text>
								</template>
								<button class="cu-btn cu-btn-sm lines-yellow round" style="margin-left: 10px;"
									@click="(showIssue = !showIssue), showIssueChange()">{{ $t("lsjl") }}</button>
							</view>
						</view>
					</view>
				</view>
			</view>
			<view class="cu-bar bg-black padding">
				<view class="action">
					<div class="bg"></div>
					<text class="text-xl text-bold text-gold">{{ $t("zhtz") }}</text>
				</view>
			</view>
			<view class="cu_card">
				<view class="cu-item grid col-3" style="background-color: rgb(51, 51, 51);">
					<button v-for="(item, index) in oddsList.rule_base" :key="index"
						class="cu-btn text-xs text-bold option"
						@click=" (activePay = item.class), changeShowPayInput(item.class, item.class_name) "
						:class="activePay == item.class ? 'bg-gradual-black-blue' : 'line-gold'">
						{{ $t(item.class_name) }} &nbsp;{{ item.odds }}
					</button>
				</view>

				<view class="cu-item grid">
					<view class="cu-form-group">
						<input v-model="sendValue" :placeholder="$t('shurujine')" maxlength="140" step="1"
							enterkeyhint="done" autocomplete="off" type="number" class="cu-input">
						<button class="cu-btn bg-gradual-black-blue shadow"
							@click="playOrder">{{ $t("touzi") }}</button>
					</view>
				</view>
			</view>
			<div class="text-center padding">
				<div class="prize-news-wrap">
					<div class="sub-title">
						<span>{{ $t("huiyuan") }}</span>
						<span>{{ $t("lun") }}</span>
						<span>{{ $t("jine") }}</span>
						<span>{{ $t("moshi") }}</span>
					</div>
					<div class="prize-news">
						<vue-seamless-scroll class="vux-marquee prize-marquee" :class-option="classOption"
							:data="message" :key="lastIssueId">
							<ul class="vux-marquee-box">
								<li class="prize-marquee-item" v-for="(item, index) in message" :key="index">
									<span class="name">{{ item.nickname }}</span>
									<span class="type">{{ item.issue }}</span>
									<span class="money">{{ item.quantity }}</span>
									<span class="date">{{ $t(item.play_method) }}</span>
								</li>
							</ul>
						</vue-seamless-scroll>
					</div>
				</div>
			</div>
		</div>
		<van-overlay v-model:show="showIssue" @click="showIssue = false">
			<view class="cu-modal show">
				<view class="cu-dialog" style="width: 80%;">
					<view class="shadow" style="border-radius: 5px;">
						<view class="grid text-center col-5 bg-gradual-black padding"
							style="border-radius: 5px; font-size: 12px; margin-bottom: 5px;">
							<view v-for="(header, index) in headers" :key="index"
								style="margin: auto; font-weight: bold;">
								{{ $t(header) }}
							</view>
						</view>
						<view style="max-height: 300px; overflow-y: auto;" @touchstart="handleTouchStart"
							@touchmove="handleTouchMove" @touchend="handleTouchEnd">
							<view v-for="(item, index) in issueList" :key="index" class="grid text-center col-5 radius"
								:class="item.code > 13 ? 'bg-gradual-red' : 'bg-gradual-fgreen'"
								style="font-size: 12px; padding: 5px; margin-bottom: 3px;">
								<view style="margin: auto;">{{ item.issue }}</view>
								<view style="margin: auto;">{{ item.site_1 }}</view>
								<view style="margin: auto;">{{ item.site_2 }}</view>
								<view style="margin: auto;">{{ item.site_3 }}</view>
								<view style="margin: auto;">{{ item.code }}</view>
							</view>
						</view>
					</view>
				</view>
			</view>
		</van-overlay>
		<div class="cu-modal" :class="{'show': showDepositModal}" @click.self="showDepositModal = false">
			<div class="cu-dialog " style="width: 60%;">
				<div class="cu-list menu">
					<div class="cu-item text-gold" @click="tixian">
						<label class="flex justify-between align-center flex-sub uni-label-pointer">
							<div class="flex-sub">USDT-TRC20</div>
						</label>
					</div>
					<div class="cu-item text-gold" @click="tixian1">
						<label class="flex justify-between align-center flex-sub uni-label-pointer">
							<div class="flex-sub">USDT-ERC20</div>
						</label>
					</div>
					<div class="cu-item text-gold" @click="tixian2">
						<label class="flex justify-between align-center flex-sub uni-label-pointer">
							<div class="flex-sub">BTC</div>
						</label>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import homeApi from "@/api/home";
	import vueSeamlessScroll from "vue-seamless-scroll/src";
	var echarts = require("echarts");
	export default {
		name: "BetRoom",
		components: {
			vueSeamlessScroll,
		},
		data() {
			return {
				amount0: 0,
				amount1: 0,
				onlineNum: 0,
				timer: null,
				time: 0,
				remainingSeconds: 0,
				countdownInterval: null,
				gamePhase: 'betting',
				showIssue: false,
				showPay: false,
				activePay: null,
				// showPayInput: false,
				betselect: null,
				id: null,
				game_id: null,
				oddsList: {
					rule_base: [],
				},
				num_code: null,
				sendValue: '',
				last_issue: "",
				issueList: null,
				issue: "",
				showFollowPay: false,
				message: [],
				game_status: 1,
				TipsTxt: "",
				user_quantity: "",
				user_quantityShow: true,
				class: "",
				FollPayItem: "",
				whether_close: null,
				timeDataFun: null,
				preizeIsPush: false,
				issuePreize: "",
				amount: '',
				numbers: [0, 0, 0],
				headers: ['lun', '黄金', '美元', '原油', '数值'],
				showDepositModal: false,
				data: [],
				gameList: "",
				// upColor: '#e54d42',
				// upBorderColor: '#e54d42',
				// downColor: '#087900',
				// downBorderColor: '#087900',
				chart: null,
				data0: {
					categoryData: [],
					values: []
				},
				lastIssueId: null,
				lastKlineData: null,
				amountMap0: [0, 21347553, 33618492, 72845194, 119362085, 209472838, 20164582, 31688912, 75728104,
					101793183, 218346728, 25892018, 31956285, 72875981, 128926091, 228561486
				],
				amountMap1: [0, 21738572, 37528459, 83429571, 138562591, 285719471, 21139372, 36349419, 85182701,
					128268189, 272589160, 28264106, 32825619, 81872569, 149165151, 291685028
				],
			};
		},
		watch: {
			issuePreize(newv, old) {
				if (newv != old) {
					this.preizeIsPush = false;
					// transform: translate3d(0, 0px, 0px);
				}
			},
		},
		computed: {
			classOption() {
				return {
					step: 0.8, // 数值越大速度滚动越快
					// limitMoveNum: 10, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: false, // 是否开启鼠标悬停stop
					preventDefaultMouseMove: true,
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
					limitMoveNum: 5
				};
			},
			money() {
				// console.log(this.$store.state.money);
				return this.$store.state.money;
			},
			currentUserId() {
				// console.log(this.$store.state.currentUserId);
				return this.$store.state.currentUserId;
			},
		},
		methods: {
			// 下注接口
			playOrder() {
				if (this.class == '' || this.class == null) {
					this.$toast(this.$t('qxztzlx'));
					return;
				}
				if (this.sendValue == '' || this.sendValue <= 0) {
					this.$toast(this.$t('tzjebnxy'));
					return;
				}
				if (!Number.isInteger(Number(this.sendValue))) {
					this.$toast(this.$t('qsrzz'));
					return;
				}
				if (this.sendValue * 1 > this.user_quantity.money * 1) {
					this.$toast(this.$t('tzjebndyzhye'));
					return;
				}
				this.$toast.loading({
					message: this.$t('jiazaizhong'),
					forbidClick: true,
					duration: 0,
				});
				homeApi
					.playOrder(
						this.issue.issue,
						this.id,
						this.game_id,
						this.class,
						this.sendValue
					)
					.then((data) => {
						this.$toast.clear();
						this.showPay = false;
						// this.showPayInput = false;
						this.num_code = null;
						this.message = [...this.message, data.data];
						this.$toast(this.$t('touzichenggong'));
						//  localStorage.setItem("money", (this.user_quantity.money*1)- ( this.sendValue*1));
						this.user_quantity.money = data.data.after_quantity;
						this.sendValue = '';
					})
					.catch((err) => {
						this.$toast.clear();
						this.$toast.fail(err.msg);
					});
			},
			changego() {
				this.$router.go(-1);
			},
			showIssueChange() {
				homeApi
					.issueList(this.game_id)
					.then((data) => {
						// console.log(data.data);
						let list = data.data;
						// let list = data.data.slice(1, 5);
						this.issueList = list;
					})
					.catch((err) => {
						this.$toast.fail(err.msg);
					});
			},
			KlineBlock(id) {
				if (this.loadingKline) return;
				this.$toast.loading({
					message: this.$t('jiazaizhong'),
					forbidClick: true,
					duration: 0,
				});

				homeApi.cand(id).then((data) => {
					if (data.data && data.data.length) {
						const kLines = data.data.map(item => item.kLine);
						if (!this.isSameData(kLines, this.lastKlineData)) {
							this.lastKlineData = kLines;
							this.splitData(kLines);
							this.updateChart();
						}
					}
					this.$toast.clear();
				}).catch(error => {
					console.error('获取K线数据失败:', error);
					this.$toast.clear();
				});
			},
			isSameData(newData, oldData) {
				if (!oldData) return false;
				if (newData.length !== oldData.length) return false;

				return JSON.stringify(newData) === JSON.stringify(oldData);
			},
			changeShowPayInput(classname, itemName) {
				this.class = classname;
				this.betselect = null;
				this.num_code = itemName;
				this.showPayInput = true;
				this.sendValue = "";
			},
			heart() {
				homeApi
					.heart(this.id, this.game_id)
					.then((data) => {
						this.last_issue = data.data.last_issue;
						this.issue = data.data.issue;
						this.game_status = data.data.game_status;
						this.user_quantity = data.data.user_quantity;
						this.time = data.data.issue.openTime1;
						this.whether_close = data.data.issue.whether_close;
						this.user_quantityShow = false;
						this.$toast.clear();
						this.startCountdown(this.time);
						if (this.lastIssueId !== data.data.issue.issue) {
							this.lastIssueId = data.data.issue.issue;
							this.KlineBlock(this.game_id);
						}
					})
					.catch((err) => {
						this.$toast.clear();
						this.$toast.fail(err.msg);
					});
			},
			difference(aArray, bArray) {
				const bArraySet = new Set(bArray);
				const resultArray = aArray.filter((item) => !bArraySet.has(item));
				return Array.from(resultArray);
			},
			getResultArray(key, aArray, bArray) {
				const aArraySimple = aArray.map((i) => i[key]); // 根据唯一标识对象数组转换为简单数组
				const bArraySimple = bArray.map((i) => i[key]);
				const allData = [...aArray, ...bArray];
				const resultArraySimple = Array.from(this.difference(aArraySimple, bArraySimple));
				// console.log( resultArraySimple.map((i) => allData.find((j) => j[key] === i)) );
				return resultArraySimple.map((i) => allData.find((j) => j[key] === i));
			},
			getDifferenceSet(arr1, arr2) {
				return arr1
					.map(JSON.stringify)
					.concat(arr2.map(JSON.stringify))
					.filter((v, i, arr) => {
						return arr.indexOf(v) === arr.lastIndexOf(v);
					})
					.map(JSON.parse);
			},
			changewa() {
				this.showDepositModal = true
			},
			tixian() {
				this.$router.push({
					path: "/tixian",
				});
			},
			tixian1() {
				this.$router.push({
					path: "/tixian1",
				});
			},
			tixian2() {
				this.$router.push({
					path: "/tixian2",
				});
			},
			startCountdown(seconds) {
				clearInterval(this.countdownInterval);
				if (seconds <= 0) {
					// 倒计时已归零，进入结算期
					this.gamePhase = 'settlement';
					this.settlementSeconds = 5 + seconds; // 结算剩余秒数
					this.remainingSeconds = 0;
				} else {
					// 正常投注期
					this.gamePhase = 'betting';
					this.remainingSeconds = seconds;
					this.settlementSeconds = 0;
				}
				this.countdownInterval = setInterval(() => {
					if (this.gamePhase === 'betting') {
						this.remainingSeconds--;
						if (this.remainingSeconds <= 0) {
							this.gamePhase = 'settlement';
							this.settlementSeconds = 5;
						}
					} else {
						this.settlementSeconds--;
						// if (this.settlementSeconds <= 0) {
						// 	// 结算期结束，重新获取新一期数据
						// 	setInterval(() => {
						// 		this.heart();
						// 	}, 2000);
						// }
					}
				}, 1000);
			},
			splitData(rawData) {
				const categoryData = [];
				const values = [];
				rawData.forEach(item => {
					if (Array.isArray(item) && item.length > 0) {
						categoryData.push(item[0]);
						values.push(item.slice(1));
					}
				});
				this.data0 = {
					categoryData,
					values
				};
				this.chart.setOption(this.getChartOption(), true);
			},
			calculateMA(dayCount) {
				const result = []
				for (let i = 0, len = this.data0.values.length; i < len; i++) {
					if (i < dayCount) {
						result.push('-')
						continue
					}
					let sum = 0
					for (let j = 0; j < dayCount; j++) {
						sum += +this.data0.values[i - j][1]
					}
					result.push(sum / dayCount)
				}
				return result
			},
			initChart() {
				this.chart = echarts.init(this.$refs.chartContainer)
				this.chart.setOption(this.getChartOption())
			},
			getChartOption() {
				return {
					tooltip: {
						// show: false,
						trigger: 'item',
						confine: true,
						triggerOn: "click",
						axisPointer: {
							type: 'cross'
						},
						// axisPointer: {
						// 	y: { type: 'none' }
						// },
						position: function(point, params, dom, rect, size) {
							const mouseX = point[0];
							const mouseY = point[1];
							const tooltipWidth = size.contentSize[0];
							const chartWidth = size.viewSize[0];
							let x = mouseX + 10;
							if (x + tooltipWidth > chartWidth) {
								x = mouseX - 10 - tooltipWidth;
								if (x < 0) {
									x = mouseX < chartWidth / 2 ? 0 : chartWidth - tooltipWidth;
								}
							}
							let y = mouseY;
							const tooltipHeight = size.contentSize[1];
							const chartHeight = size.viewSize[1];

							if (y + tooltipHeight > chartHeight) {
								y = chartHeight - tooltipHeight;
							}
							return [x, y];
						},
						backgroundColor: 'rgba(0, 0, 0, 0.7)',
						borderWidth: 1,
						padding: [3, 5],
						formatter: function(params) {
							console.log(params)
							const data = params.data;
							const date = params.name;
							const open = data[1];
							const close = data[2];
							const low = data[3];
							const high = data[4];

							const isUp = close > 13;
							const color = isUp ? '#f04664' : '#30c15d';
							return `
							<div style="display:flex;align-items:center;font-size:12px;color:#fff;">
								<span style="display:inline-block;margin-right:5px;width:10px;height:10px;border-radius:50%;background:${color}"></span>
								<div style="width:40px;">黄金：</div>
								<div style="flex:1;text-align:left;">${open}</div>
							</div>
							<div style="display:flex;align-items:center;font-size:12px;color:#fff;">
								<span style="display:inline-block;margin-right:5px;width:10px;height:10px;border-radius:50%;background:${color}"></span>
								<div style="width:40px;">美元：</div>
								<div style="flex:1;text-align:left;">${low}</div>
							</div>
							<div style="display:flex;align-items:center;font-size:12px;color:#fff;">
								<span style="display:inline-block;margin-right:5px;width:10px;height:10px;border-radius:50%;background:${color}"></span>
								<div style="width:40px;">原油：</div>
								<div style="flex:1;text-align:left;">${high}</div>
							</div>
							<div style="display:flex;align-items:center;font-size:12px;color:#fff;">
								<span style="display:inline-block;margin-right:5px;width:10px;height:10px;border-radius:50%;background:${color}"></span>
								<div style="width:40px;">数值：</div>
								<div style="flex:1;text-align:left;">${close}</div>
							</div>
							<div style="display:flex;align-items:center;font-size:12px;color:#fff;">
								<span style="display:inline-block;margin-right:5px;width:10px;height:10px;border-radius:50%;background:#f04664"></span>
								<div style="width:40px;">期数：</div>
								<div style="flex:1;text-align:left;">${date}</div>
							</div>
						`;
						},
					},
					grid: {
						left: '1%',
						right: '1%',
						bottom: '1%',
						top: '15%',
					},
					// dataZoom: [
					// 	{
					// 		type: 'inside',
					// 		xAxisIndex: 0,
					// 		filterMode: 'filter',
					// 		start: 80,
					// 		end: 100,
					// 		zoomOnMouseWheel: false,
					// 		moveOnMouseMove: true,
					// 		preventDefaultMouseMove: true
					// 	}
					// ],
					xAxis: {
						type: 'category',
						data: this.data0.categoryData,
						axisLine: {
							onZero: false
						},
						splitLine: {
							show: false
						},
						min: 'dataMin',
						max: 'dataMax',
						axisLabel: {
							show: false
						},
						axisPointer: {
							label: {
								show: false
							},
							lineStyle: {
								type: 'solid',
							}
						},
						// splitLine: { show: false }
					},
					yAxis: {
						scale: true,
						min: -20,
						max: 30,
						axisLabel: {
							show: false
						},
						splitLine: {
							lineStyle: {
								type: 'dashed'
							}
						},
						axisPointer: {
							type: 'none',
							label: {
								show: false
							}
						},
					},
					visualMap: {
						show: false,
						dimension: 2,
						pieces: [{
							gt: 13.5,
							color: '#f04664'
						}, {
							lte: 13.5,
							color: '#30c15d'
						}]
					},
					series: [{
						type: 'candlestick',
						barWidth: 4,
						data: this.data0.values,
						itemStyle: {
							color: null,
							color0: null,
							borderColor: null,
							borderColor0: null
						},
						markLine: {
							symbol: ['none', 'none'],
							label: {
								show: false
							},
							lineStyle: {
								color: '#f04664',
							},
							silent: true,
							data: [{
									name: 'min line on close',
									type: 'value',
									yAxis: '8'
								},
								{
									name: 'max line on close',
									type: 'value',
									yAxis: '17'
								}
							]
						}
					}]
				}
			},
			updateChart() {
				if (this.chart) {
					this.chart.setOption(this.getChartOption(), true);
				}
			},
			startTimer() {
				if (this.timer) clearInterval(this.timer);

				this.timer = setInterval(() => {
					this.updateRandomNumber();
					this.addAmount();
				}, 5000);
			},
			updateRandomNumber() {
				const baseValue = Number(this.onlineNum);
				const fluctuation = baseValue * 0.1;
				this.onlineNum = Math.round(baseValue + (Math.random() * 2 - 1) * fluctuation);
			},
			addAmount() {
				const randomAmount = Math.round(Math.abs(Math.random() * (4999 - 99) + 99));
				const newAmount0 = Math.round(this.amount0 + randomAmount);
				const newAmount1 = Math.round(this.amount1 + randomAmount + 5678);
				this.amount0 = Math.max(0, newAmount0);
				this.amount1 = Math.max(0, newAmount1);

				this.saveAmount();
			},
			saveAmount() {
				localStorage.setItem('savedAmount0', Math.max(0, this.amount0).toString());
				localStorage.setItem('savedAmount1', Math.max(0, this.amount1).toString());
			},
			loadAmount() {
				const saved0 = localStorage.getItem('savedAmount0');
				const saved1 = localStorage.getItem('savedAmount1');
				if (saved0) this.amount0 = Math.max(0, parseFloat(saved0));
				if (saved1) this.amount1 = Math.max(0, parseFloat(saved1));
			},
			handleTouchStart(e) {
				this.startY = e.touches[0].clientY;
				this.scrollTop = e.currentTarget.scrollTop;
				e.currentTarget.style.transition = 'none';
			},
			handleTouchMove(e) {
				const deltaY = e.touches[0].clientY - this.startY;
				e.currentTarget.scrollTop = this.scrollTop - deltaY;
				e.preventDefault();
			},
			handleTouchEnd(e) {
				this.$nextTick(() => {
					e.currentTarget.style.transition = '';
				});
			},
		},

		mounted() {
			this.startTimer();
			this.initChart();
			this.startCountdown(this.time);
			setInterval(() => {
				this.numbers = Array.from({
						length: 3
					},
					() => Math.floor(Math.random() * 10))
			}, 1000)
		},
		onUpdated() {},
		unmounted() {
			if (this.timer) clearInterval(this.timer);
			clearInterval(this.countdownInterval);
			clearInterval(this.timeDataFun);
			this.timeDataFun = null;
		},
		created() {
			let that = this;
			this.$toast.loading({
				message: this.$t('jiazaizhong'),
				forbidClick: true,
				duration: 0,
			});
			this.addAmount();
			this.loadAmount();

			this.id = this.$route.query.id;
			this.game_id = this.$route.query.game_id;
			this.onlineNum = this.$route.query.onlineNum;
			this.KlineBlock(this.game_id);

			const amountId = Number(this.id);
			if (amountId) {
				this.amount0 = this.amountMap0[amountId];
				this.amount1 = this.amountMap1[amountId];
			}
			homeApi
				.oddsList(this.id)
				.then((data) => {
					this.oddsList = data.data;
					this.$toast.clear();
				})
				.catch((err) => {
					this.$toast.clear();
					this.$toast.fail(err.msg);
				});
			this.heart();
			that.$nextTick(() => {
				this.timeDataFun = setInterval(() => {
					// 对接接口就是轮询后有新数据就进行滚动
					//需要定时执行的代码
					homeApi
						.heart(this.id, this.game_id)
						.then((data) => {
							this.last_issue = data.data.last_issue;
							if (!this.preizeIsPush && data.data.hit_notice) {
								this.preizeIsPush = true;
							}
							if (that.message.length != 0) {
								this.game_status = data.data.game_status;
								this.time = data.data.issue.openTime1;
								this.issue = data.data.issue;
								this.issuePreize = data.data.issue.issue;
								this.user_quantity = data.data.user_quantity;
								this.whether_close = data.data.issue.whether_close;
								this.startCountdown(this.time);
								if (this.lastIssueId !== data.data.issue.issue) {
									const keepCount = Math.min(5, this.message.length);
									const keepMessages = this.message.slice(-keepCount);
									if (data.data && data.data.message) {
										this.message = [...keepMessages, ...data.data.message];
										this.message = data.data.message;
										this.KlineBlock(this.game_id);
									}
								} else {
									// 否则执行原有差异更新
									let newlist = this.getDifferenceSet(this.message, data.data
										.message);
									if (newlist.length) this.message = [...this.message, ...newlist];
								}
								// console.log(this.whether_close, "this.whether_close");

								if (data.data.message.length != 0 && data.data.message) {
									let newlist = that.getDifferenceSet(
										that.message,
										data.data.message
									);
									if (newlist.length != 0) {
										//  取相差有问题
										if (that.message.length > 150) {
											that.message.splice(1, 30)
										}
										// that.message.push(...newlist);
										that.message = [...that.message, ...newlist];
										// console.log(newlist);
									}
								}
							} else {
								if (that.message.length == 0 && data.data.message.length != 0 && data
									.data.message) {
									that.message = data.data.message;
								}
							}
							this.$toast.clear();
						})
						.catch(() => {
							this.$toast.clear();
							// this.$toast.fail(err.msg);
						});
				}, 3000);
			});
		},
	};
</script>
<style lang="less" scoped>
	.betRoom {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		height: 100%;
	}

	.bet-head {
		overflow: hidden;
		text-align: center;
		// background: #1a243f;
		// padding: 0.4rem;
		// margin-bottom: 0.2rem;
		font-size: 0.35rem;
		// z-index: 2003;
		margin: 15px;
		background-image: url(../assets/trade/bet_back.png);
		background-size: cover;
		background-repeat: no-repeat;
		min-height: 150px;
		border-radius: 5px;

		.left {
			flex: 1;
			position: relative;
		}

		.left ::after {
			content: "";
			display: block;
			width: 1px;
			height: 0.8rem;
			position: absolute;
			background-color: #e5e5e5;
			right: 0;
			top: 50%;
			-webkit-transform: translateY(-50%);
			transform: translateY(-50%);
		}

		.right {
			-webkit-box-flex: 1;
			-ms-flex: 1;
			flex: 1;
			padding-left: 0.25rem;
			font-size: 0.4rem;
			position: relative;
		}
	}

	.g-content {
		flex: 1;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		// overflow-y: hidden;
		background-color: #333;
	}

	.odds {
		margin-left: auto;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		min-width: 1.6rem;

		img {
			width: 0.32rem;
			height: 0.32rem;
			margin-right: 0.1rem;
		}

		span {
			color: #ff7d20;
		}
	}

	.swiperKey {
		margin: 0 auto;
		position: relative;
		overflow: hidden;
		list-style: none;
		padding: 0;
		z-index: 1;
		width: 100%;
	}

	.select-list {
		padding: 0 0.12rem;
	}

	.item {
		width: 25%;
		float: left;
		text-align: center;
		margin-bottom: 0.4rem;
	}

	.bet {
		width: 7rem;
		background-color: #374c7c;
		border-radius: 0.2rem;
		overflow: hidden;
		top: 35%;
		position: absolute;
		left: 15%;
	}

	@keyframes righttoleftpiaopping {

		/*设置内容由显示变为隐藏*/
		0% {
			transform: translate3d(-300px, 0px, 0px);
			opacity: 1;
		}

		50% {
			transform: translate3d(0, 0px, 0px);
			opacity: 1;
		}

		50% {
			transform: translate3d(200px, 0px, 0px);
			opacity: 1;
		}

		100% {
			transform: translate3d(500px, 0px, 0px);
			opacity: 0;
		}
	}

	view {
		display: block;
	}

	.bet-charge {
		background-image: url(../assets/trade/bet_icon.png);
		background-size: cover;
		background-repeat: no-repeat;
		height: 33px;
		width: 104px;
		float: right;
		margin-top: 15px;
		line-height: 33px;
		text-align: center;
		color: #db9208;
		font-size: 13px;
	}

	.bet-property {
		display: block;
		width: 100%;
		height: 76.8px;
		text-align: left;
	}

	.bg-black {
		background-color: #333;
		color: #fff;
	}

	.padding {
		padding: 15px;
	}

	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}

	.text-bold {
		font-weight: 700;
	}

	.text-center {
		text-align: center;
	}

	.grid {
		display: flex;
		flex-wrap: wrap;
	}

	.col-3>view {
		width: 33.33%;
	}

	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 50px;
		justify-content: space-between;
	}

	.cu-bar .action {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: center;
		max-width: 100%;
		margin-right: 15px;
		font-size: 15px;
	}

	.text-yellow,
	.line-yellow,
	.lines-yellow {
		color: #fbbd08;
	}

	.bg {
		width: 5px;
		height: 17px;
		border-radius: 2px;
		background: #fbbd08;
		margin-right: 8px;
	}

	.text-xl {
		font-size: 19px;
	}

	.round {
		border-radius: 2500px;
	}

	.cu-btn.round[class*="line"]::after {
		border-radius: 500px;
	}

	.cu-btn[class*="lines"]::after {
		border: 3px solid currentColor;
	}

	.cu_card {
		display: block;
		// overflow: hidden;
	}

	.cu_card>.cu-item {
		display: block;
		// background-color: #fff;
		overflow: hidden;
		border-radius: 4px;
		margin: 14px;
	}

	.cu-btn {
		position: relative;
		border: 0px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 0 14px;
		font-size: 13px;
		height: 31px;
		line-height: 1;
		text-align: center;
		text-decoration: none;
		overflow: visible;
		margin-left: 0;
		-webkit-transform: translate(0px, 0px);
		transform: translate(0px, 0px);
		margin-right: 0;
	}

	.cu-btn-sm {
		padding: 0 10px;
		font-size: 10px;
		height: 24px;
	}

	.text-xs {
		font-size: 9px;
	}

	.option {
		margin-left: 1%;
		margin-top: 10px;
		width: 32.3%;
		padding: 0px;
	}

	.cu-btn[class*="line"]::after {
		content: " ";
		display: block;
		width: 200%;
		height: 200%;
		position: absolute;
		top: 0;
		left: 0;
		border: 1px solid currentColor;
		-webkit-transform: scale(.5);
		transform: scale(.5);
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		box-sizing: border-box;
		border-radius: 5px;
		z-index: 1;
		pointer-events: none;
	}

	.cu-form-group {
		background-color: #fff;
		padding: 1px 14px;
		display: flex;
		align-items: center;
		min-height: 48px;
		justify-content: space-between;
		border: 1px solid #b8a78a;
	}

	.cu-input {
		min-height: 45px;
		color: #555;
		font-size: 14px;
	}

	.cu-input::placeholder {
		color: #999;
		opacity: 1;
		font-size: 14px;
	}

	.bg-gradual-black-blue {
		background-image: linear-gradient(45deg, #0d99e6, #191a1a);
		color: #fff;
		border-radius: 5px;
	}

	.shadow[class*="-black"] {
		box-shadow: 2px 2px 3px rgba(26, 26, 26, .2);
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.record-thead {
		border-radius: 5px;
		font-size: 12px;
		margin-bottom: 5px;
	}

	.col-5>view {
		width: 20%;
		margin: auto;
		font-weight: bold;
	}

	.radius {
		border-radius: 3px;
	}

	.cu-tag {
		font-size: 12px;
		vertical-align: middle;
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 0px 8px;
		height: 24px;
		font-family: Helvetica Neue, Helvetica, sans-serif;
		white-space: nowrap;
	}

	.bg-red {
		background-color: #e54d42;
		color: #fff;
	}

	.bg-green {
		background-color: #087900;
		color: #fff;
	}

	.van-count-down {
		color: #b8a78a;
		font-size: 16px;
		line-height: 30px;
		display: inline;
	}

	.van-overlay {
		background: rgba(0, 0, 0, .6);
	}

	.cu-modal {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 1110;
		opacity: 0;
		outline: 0;
		text-align: center;
		-ms-transform: scale(1.185);
		-webkit-transform: scale(1.185);
		transform: scale(1.185);
		-webkit-backface-visibility: hidden;
		backface-visibility: hidden;
		-webkit-perspective: 1000px;
		perspective: 1000px;
		transition: all .3s ease-in-out 0s;
		pointer-events: none;
	}

	.show {
		opacity: 1;
		transition-duration: .3s;
		-ms-transform: scale(1);
		-webkit-transform: scale(1);
		transform: scale(1);
		overflow-x: hidden;
		overflow-y: auto;
		pointer-events: auto;
	}

	.cu-modal::before {
		content: "\200B";
		display: inline-block;
		height: 100%;
		vertical-align: middle;
	}

	.cu-dialog {
		position: relative;
		display: inline-block;
		vertical-align: middle;
		margin-left: auto;
		margin-right: auto;
		width: 362px;
		max-width: 100%;
		background-color: #f8f8f8;
		border-radius: 5px;
		overflow: hidden;
	}

	.bg-gradual-fgreen {
		background-image: linear-gradient(45deg, #39b54a, #087900);
		color: #fff;
	}

	.bg-gradual-red {
		background-image: linear-gradient(45deg, #f43f3b, #ec008c);
		color: #fff;
	}

	.prize-news-wrap {
		// padding-bottom: 50px;
		// margin-top: 0.2rem;
	}

	.sub-title {
		border-radius: 5px;
		display: flex;
		text-align: center;
		font-size: 12px;
		color: #b8a78a;
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		flex: 1;
		padding: 16px 0 16px 0;

		span {
			flex: 1;
		}
	}

	.prize-news {
		border-radius: 5px;
		display: flex;
		text-align: center;
		font-size: 12px;
		// color: #b8a78a;
		// background-image: linear-gradient(45deg, #191a1a, #8799a3);
		flex: 1;
		padding: 0.1rem 0 0.1rem;
	}

	.vux-marquee {
		width: 100%;
		overflow: hidden;
		height: 300px;
		pointer-events: none;
	}

	.vux-marquee-box {
		padding: 0;
		margin: 0;
		width: 100%;
		height: auto;
	}

	.prize-marquee {
		height: 250px !important;
		font-size: 12px;
	}

	.prize-marquee-item:nth-child(odd) {
		border-radius: 5px;
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		margin-bottom: 5px;
		height: 35px;
		line-height: 35px;
		display: flex;
		align-items: center;
		-ms-flex-pack: distribute;
		justify-content: space-around;
	}

	.prize-marquee-item:nth-child(even) {
		border-radius: 5px;
		background-image: linear-gradient(45deg, #0d99e6, #191a1a);
		margin-bottom: 5px;
		height: 35px;
		line-height: 35px;
		display: flex;
		align-items: center;
		-ms-flex-pack: distribute;
		justify-content: space-around;
	}

	.prize-marquee-item span {
		display: inline-block;
		text-align: center;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		flex: 1;
	}

	.prize-marquee-item .name,
	.prize-marquee-item .money {
		color: #b8a78a;
	}

	.prize-marquee-item .type,
	.prize-marquee-item .date {
		color: #b8a78a;
	}

	.cu-modal.show {
		opacity: 0;
		transition-duration: .3s;
		-ms-transform: scale(1);
		-webkit-transform: scale(1);
		transform: scale(1);
		overflow-x: hidden;
		overflow-y: auto;
		pointer-events: auto;
	}

	.cu-modal.show {
		opacity: 1;
		pointer-events: auto;
		transform: scale(1);
	}

	.flex-sub {
		flex: 1;
	}

	.custom-countdown {
		font-size: 16px;
		display: inline;
	}


	.kline-chart {
		width: 100%;
		height: 120px;
	}
</style>